export const storageKeys = {
  user: '@ventas:usuario-logado',
  atendimento: '@ventas:atendimento',
  simulador_form: '@ventas:simulador-form',
} as const
